/** @deprecated 旧版节点模式组件，已被 GenerateNode + CardContentRenderer 统一架构替代。请勿在此添加新功能 */
import React, { useState, memo } from 'react';
import { AppNode, NodeStatus } from '@/types';
import { NodeHeader, InputPorts, OutputPorts, ModelSelector, PromptInput, GenerateButton, MediaPreview } from '../parts';

interface Txt2ImgModeProps {
  node: AppNode;
  onUpdate: (id: string, data: Partial<AppNode['data']>) => void;
  onAction: (id: string, prompt?: string) => void;
  onDelete: (id: string) => void;
  isConnecting?: boolean;
  onPortMouseDown: (e: React.MouseEvent, id: string, type: 'input' | 'output') => void;
  onPortMouseUp: (e: React.MouseEvent, id: string, type: 'input' | 'output') => void;
}

const Txt2ImgModeInner: React.FC<Txt2ImgModeProps> = ({
  node,
  onUpdate,
  onAction,
  onDelete,
  isConnecting,
  onPortMouseDown,
  onPortMouseUp,
}) => {
  const [prompt, setPrompt] = useState(node.data.prompt || '');
  const isWorking = node.status === NodeStatus.WORKING;

  const handlePromptChange = (value: string) => {
    setPrompt(value);
    onUpdate(node.id, { prompt: value });
  };

  const handleGenerate = () => {
    onAction(node.id, prompt);
  };

  const handleModelChange = (modelId: string) => {
    onUpdate(node.id, { model: modelId });
  };

  return (
    <div className="relative">
      <NodeHeader
        node={node}
        onUpdate={onUpdate}
        onDelete={onDelete}
      />
      
      <InputPorts
        node={node}
        isConnecting={isConnecting}
        onPortMouseDown={onPortMouseDown}
        onPortMouseUp={onPortMouseUp}
      />
      
      <div className="p-3 flex flex-col gap-2">
        <MediaPreview
          type="image"
          status={node.status}
          src={node.data.image || ''}
          error={node.data.error}
        />
        
        <PromptInput
          value={prompt}
          placeholder="描述您想生成的图�?.."
          onChange={handlePromptChange}
          onSubmit={handleGenerate}
          disabled={isWorking}
        />
        
        <div className="flex items-center justify-between">
          <ModelSelector
            mode="txt2img"
            selectedModel={node.data.model || ''}
            onChange={handleModelChange}
            disabled={isWorking}
          />
          
          <GenerateButton
            status={node.status}
            onClick={handleGenerate}
          />
        </div>
      </div>
      
      <OutputPorts
        node={node}
        isConnecting={isConnecting}
        onPortMouseDown={onPortMouseDown}
        onPortMouseUp={onPortMouseUp}
      />
    </div>
  );
};

export const Txt2ImgMode = memo(Txt2ImgModeInner, (prevProps, nextProps) => {
  return (
    prevProps.node.id === nextProps.node.id &&
    prevProps.node.status === nextProps.node.status &&
    prevProps.node.data?.model === nextProps.node.data?.model &&
    prevProps.node.data?.image === nextProps.node.data?.image &&
    prevProps.node.data?.prompt === nextProps.node.data?.prompt &&
    prevProps.node.data?.error === nextProps.node.data?.error &&
    prevProps.isConnecting === nextProps.isConnecting
  );
});